import DOMPurify from 'dompurify';
import { safeHref } from './safeHref';

const ALLOWED_TAGS = [
  'a',
  'b',
  'blockquote',
  'br',
  'code',
  'em',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'hr',
  'i',
  'img',
  'li',
  'ol',
  'p',
  'pre',
  's',
  'span',
  'strong',
  'table',
  'tbody',
  'td',
  'th',
  'thead',
  'tr',
  'u',
  'ul',
];

const ALLOWED_ATTR = ['alt', 'class', 'href', 'rel', 'src', 'target', 'title'];

function applySafeUri(_node, data) {
  if (data.attrName !== 'href' && data.attrName !== 'src') return;
  const next = safeHref(data.attrValue);
  if (!next) {
    data.keepAttr = false;
    return;
  }
  data.attrValue = next;
}

/**
 * Blank-target anchors must not keep window.opener. Merge onto any
 * existing rel tokens and drop opener so a stored rel cannot undo it.
 */
function applyBlankTargetRel(node) {
  if (!node || node.nodeName !== 'A') return;
  if (node.getAttribute('target') !== '_blank') return;
  const tokens = String(node.getAttribute('rel') || '')
    .split(/\s+/)
    .filter((token) => token && token !== 'opener');
  if (!tokens.includes('noopener')) tokens.push('noopener');
  if (!tokens.includes('noreferrer')) tokens.push('noreferrer');
  node.setAttribute('rel', tokens.join(' '));
}

// Own instance so these hooks never leak into other DOMPurify callers.
const purify = DOMPurify(window);
purify.addHook('uponSanitizeAttribute', applySafeUri);
purify.addHook('afterSanitizeAttributes', applyBlankTargetRel);

/**
 * Sanitize marked HTML before v-html. Strips script/iframe/object,
 * event handlers, and javascript:/data:/protocol-relative hrefs.
 * URI policy is safeHref — same helper page nodes use. Blank-target
 * anchors always get rel="noopener noreferrer".
 *
 * @param {string} html
 * @returns {string}
 */
export function sanitizeRenderedHtml(html) {
  if (!html) return '';
  return purify.sanitize(html, {
    ALLOWED_TAGS,
    ALLOWED_ATTR,
    FORBID_ATTR: ['srcdoc'],
  });
}
